import React, { useEffect, useState } from "react";
import { Switch, Tooltip } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { fetchHomeCardData, setHomeCardData } from "action/actions";
import { getLocalStorage } from "helper/localStorage";
import { setLocalStorage } from "helper/localStorage";

const ToggleRefreshApi = (props) => {
  const [intervalId, setIntervalId] = useState(0);
  const [toggleButton, setToggleButton] = useState(false);

  const handleRefresh = (e) => {
    if (window.location.pathname === "/") {
      if (e) {
        setIntervalId(setInterval(() => props.fetchHomeCardData(), 600000));
      } else {
        clearInterval(intervalId);
      }
    } else {
      clearInterval(intervalId);
    }
  };

  const handleSwitch = (e) => {
    // const params = getLocalStorage("params");
    // params.autoRefresh = e;
    // setLocalStorage("params", params);
    setToggleButton(e);
    props.setHomeCardData(e);
  };

  useEffect(() => {
    handleRefresh(toggleButton);
  }, [props.match.path, toggleButton]);

  return (
    <>
      <div
        className="d-flex mt-2"
        style={{ background: "none", color: "#525f7f" }}
      >
        <div className="mr-2">
          <Tooltip title="Automatically refreshes the home page after every 10 mins">
            <span className="text-muted small m-0"> Auto Refresh </span>
          </Tooltip>
        </div>
        <Switch
          checkedChildren="On"
          unCheckedChildren="Off"
          onChange={handleSwitch}
          // defaultChecked={getLocalStorage("params")?.autoRefresh || false}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch, store) => {
  return {
    fetchHomeCardData: () => dispatch(fetchHomeCardData()),
    setHomeCardData: (data) => dispatch(setHomeCardData(data)),
  };
};

export default connect(null, mapDispatchToProps)(withRouter(ToggleRefreshApi));
